export const servicePages = [
	{
		key: 'devops-automation',
		path: '/devops-automation',
		seoTitle: 'DevOps Automation Services for Canadian Teams | BrokenCosmos Labs',
		seoDescription:
			'DevOps automation services for Canadian teams that need faster releases, lower operational overhead, and dependable cloud delivery.',
		h1: 'DevOps Automation for Faster, Safer Releases',
		kicker: 'DevOps Automation',
		intro:
			'We help engineering teams in Toronto, the GTA, and across Canada automate delivery pipelines, standardize releases, and reduce production risk.',
		outcomes: [
			'Reduce manual deployment steps and release delays.',
			'Improve reliability with repeatable CI/CD pipelines.',
			'Increase team confidence through observability and release controls.',
		],
		deliverables: [
			'CI/CD pipeline architecture and implementation',
			'Infrastructure as Code foundations',
			'Environment promotion workflows',
			'Monitoring, alerting, and incident-response readiness',
		],
	},
	{
		key: 'custom-software-development',
		path: '/custom-software-development',
		seoTitle: 'Custom Software Development in Canada | BrokenCosmos Labs',
		seoDescription:
			'Custom software development for Canadian businesses that need scalable products, cleaner architecture, and stronger delivery quality.',
		h1: 'Custom Software Development That Scales Cleanly',
		kicker: 'Custom Software Development',
		intro:
			'We build and modernize custom software for companies that need stable architecture, strong UX, and long-term maintainability.',
		outcomes: [
			'Ship product improvements with less technical debt.',
			'Create clearer user journeys and stronger conversion paths.',
			'Improve maintainability for internal engineering teams.',
		],
		deliverables: [
			'Product and platform architecture',
			'Full-stack application engineering',
			'Legacy system modernization and refactors',
			'Quality standards, testing strategy, and delivery process',
		],
	},
	{
		key: 'ai-integrations',
		path: '/ai-integrations',
		seoTitle: 'AI Integration Services for Web Products | BrokenCosmos Labs',
		seoDescription:
			'AI integration services that add practical automation, assistant workflows, and data-aware product features without destabilizing your stack.',
		h1: 'AI Integrations That Improve Real Workflows',
		kicker: 'AI Integration Services',
		intro:
			'We integrate AI capabilities into existing products and operations, focused on measurable workflow gains rather than novelty features.',
		outcomes: [
			'Automate repetitive internal and client-facing tasks.',
			'Improve support and operational response time.',
			'Add data-informed product features that create buyer value.',
		],
		deliverables: [
			'AI workflow discovery and prioritization',
			'Tooling integrations and data pipelines',
			'Prompt and model orchestration patterns',
			'Governance and fallback behavior for production safety',
		],
	},
	{
		key: 'cloud-architecture',
		path: '/cloud-architecture',
		seoTitle: 'Cloud Architecture & Platform Engineering | BrokenCosmos Labs',
		seoDescription:
			'Cloud architecture and platform engineering for teams that need resilient infrastructure, cleaner environments, and better scalability.',
		h1: 'Cloud Architecture Built for Reliability and Growth',
		kicker: 'Cloud Architecture',
		intro:
			'We design and refine cloud foundations so your product can scale predictably with stronger reliability, security posture, and cost control.',
		outcomes: [
			'Improve uptime and reduce avoidable incidents.',
			'Standardize environments for smoother engineering workflows.',
			'Plan capacity and architecture with fewer scaling bottlenecks.',
		],
		deliverables: [
			'Cloud environment and network design',
			'Platform hardening and security baseline improvements',
			'Scalability planning and architecture reviews',
			'Operational runbooks and reliability process improvements',
		],
	},
];
